/**
 * 投诉须知**正文** —— 手机端与 PC 端共用这一份。
 *
 * ════════ 为什么抽出来 ════════
 *
 * 2026-09-07 主公要 PC 端也加须知闸（同意后才显示表单）。正文是**协会的正式文本**
 * （逐字照 t1.html，不改写、不缩写），抄第二份的话，将来协会改一个字就会出现
 * 「手机端已改、PC 端还是旧版」——而这份文本是投诉人点「同意」时同意的东西，
 * 两端不一致等于两批人同意了不同的条款。所以正文只有这一份。
 *
 * ★ 这个组件**只负责正文**，不带页头、不带底部同意栏：
 *   两端的外壳与「同意」交互差别很大（手机端是底部固定栏 ＋ 整页路由跳转，
 *   PC 端是卡片内的同意区 ＋ 就地切换到表单），硬统一反而要塞一堆开关。
 *   共用必须共用的（协会文本），各写各的（外壳交互）。
 *
 * ★ 类名沿用手机端那套（`nz` / `nz-h` / `nz-bar` / `sub` / `em` / `endnote`）：
 *   PC 端在 `pc.css` 里按同名类另写一份排版即可，不必改结构。
 */
export function NoticeBody() {
  return (
    <>
      <div className="nz">
        <div className="nz-h">
          <span className="nz-bar" />
          <h3>一、客户投诉须知的确认</h3>
        </div>
        <p>
          （一）发布投诉前，请您仔细阅读须知内容。如您对须知内容或页面提示信息有疑问，请联系本协会。您通过网络页面点击“同意”并进行投诉操作或签字同意本投诉须知，即表示您已知悉须知内容。
        </p>
        <p>（二）本协会有权修改须知内容，请以投诉时页面展示或签字时内容为准。</p>
      </div>

      <div className="nz">
        <div className="nz-h">
          <span className="nz-bar" />
          <h3>二、您发布或填写投诉信息时，需遵守法律法规的规定</h3>
        </div>
        <p>
          （一）为建立公平健康的投诉环境，搭建本协会与市民群众、从业人员或行业机构的有效沟通渠道，请您依法、据实发布投诉内容，不得虚构投诉捏造夸大事实，不得诬陷诽谤他人、泄露他人隐私，不得使用诋毁、辱骂性的语言损害他人声誉。
        </p>
        <p>
          （二）在任何情况下，投诉人均不得复制、发布、传播含有下列内容的信息：危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一；煽动民族仇恨、民族歧视，破坏民族团结；宣扬邪教和封建迷信；散布谣言，扰乱社会秩序，破坏社会稳定；散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪；其他含有法律、行政法规禁止的内容。一经发现，本协会将立即做删除处理，必要情况下，本协会有权将上述内容作为证据提交予国家有关部门以配合调查。
        </p>
        <p>
          如果您违反以上规则，本协会有权<span className="em">将您的投诉视为无效投诉</span>。
        </p>
      </div>

      <div className="nz">
        <div className="nz-h">
          <span className="nz-bar" />
          <h3>三、为了您更好的完成投诉，请仔细阅读并了解以下内容</h3>
        </div>
        <p>
          （一）您的信任对本协会非常重要，本协会深知用户信息安全的重要性，本协会将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。
        </p>
        <p>
          （二）为保证您的合理诉求得到及时满足，请填写有效联系方式，联系方式包括但不限于手机号码、邮箱等。便于本协会及时与您取得联系，核实信息，告知投诉进展。
        </p>
        <p>
          （三）填写投诉内容时，请注意严谨措辞，请勿使用不文明用语。您所提交的投诉内容中，如有本协会认为存在过激或不当用语的，视严重程度，本协会有权视为无效投诉进行撤销、删除、不予记录等处理；
        </p>
        <p>
          （四）投诉者请完整、详细填写投诉信息，不得遗漏每一项，完成投诉后请耐心等候工作人员受理，处理结果可通过协会官网进行查看。
        </p>
        <p>
          （五）<span className="em">投诉为实名投诉</span>，投诉人应当准确、具体填写下列材料：
        </p>
        <div className="sub">
          <p>1、投诉人的姓名、联系方式；</p>
          <p>2、被投诉人的名称（姓名）、联系方式；</p>
          <p>3、具体的投诉请求、消费者权益争议事实以及相应的证据材料。</p>
        </div>
        <p>（六）投诉人为两人以上，基于同一权益争议投诉同一经纪机构或从业人员的，可以按共同投诉处理。</p>
        <p>
          （七）投诉有下列情形之一的，将<span className="em">不予受理</span>，视为无效投诉：
        </p>
        <div className="sub">
          <p>1、投诉事项不属于行业自律管理范围内，或者本协会不具有处理权限的；</p>
          <p>2、非当事人，即不能证明与被投诉人之间存在权益争议的；</p>
          <p>3、除法律另有规定外，投诉人知道或者应当知道自己的权益受到被投诉人侵害之日起超过一年的；</p>
          <p>4、资料不齐的，理由不充分或反复提交的投诉申请；</p>
          <p>5、未按照本须知规定填写的；</p>
          <p>6、法律、法规、规章规定不予受理的其他情形。</p>
        </div>
        <p>
          （八）发布投诉时应提交有合法来源的图片、音频、视频，作为投诉的举证材料，未提交材料的，视为证据不足，投诉人应补正以便核查。
        </p>
        <p>
          （九）本协会需要定期或不定期地对网络平台的全部或部分功能检修及维护，有权变更、中断部分或全部的投诉平台使用，并删除您在投诉时提交的任何资料，而无需通知您，也无需对任何用户或任何第三方承担任何责任。请您妥善保存个人资料。
        </p>
      </div>

      <div className="nz">
        <div className="nz-h">
          <span className="nz-bar" />
          <h3>四、关于无效投诉的处理办法</h3>
        </div>
        <p>如果您提交的投诉内容涉及上述规则中关于无效投诉的规定范围，本协会有权对该条投诉采取如下一项或多项措施处理：</p>
        <div className="sub">
          <p>1、将该条投诉视为无效投诉；</p>
          <p>2、对投诉作审核未通过处理；</p>
          <p>3、将投诉内容作撤销、删除等处理；</p>
        </div>
      </div>

      <div className="nz">
        <div className="nz-h">
          <span className="nz-bar" />
          <h3>五、关于投诉结果回复方式</h3>
        </div>
        <p>协会将通过官网公示或电话回复方式告知投诉结果，请注意查看。</p>
        <p>
          以上内容请知悉，希望您的诉求尽快得到合理满意的答复。如您对投诉过程或对须知有任何疑问、意见或建议，可以通过邮箱、热线等方式与我们取得联系并反馈。
        </p>
      </div>

      <div className="endnote">
        <p>成都市房地产经纪协会</p>
      </div>
    </>
  );
}
